
import React, { useState, useEffect } from 'react';

import { FungibleTokenMetaData, ONE_ALPH, addressFromContractId, hexToString, prettifyAttoAlphAmount, prettifyTokenAmount, stringToHex, waitForTxConfirmation, web3 } from '@alephium/web3';
import { AlephiumConnectButton, useWallet } from '@alephium/web3-react';
import { RocketRange, RocketRangeTypes } from '../../artifacts/ts';
import { getContractConfig } from '../../services/utils';
import { LeaderboardEntry, RocketRangeGameInstance, RocketRangeUserBet } from 'src/artifacts/ts/types';
import { Leaderboard, LeaderboardTypes } from 'src/artifacts/ts/Leaderboard';
import RocketRangeLeaderboard from 'src/pages/rocketRange/RocketRangeLeaderboard';
import RocketRangePastRound from './RocketRangePastRound';
import RocketRangeCurrentRound from './RocketRangeCurrentRound';
import EventsDashboard from './EventsDashboard';

export default function RocketRangeAdmin() {
    web3.setCurrentNodeProvider(process.env.REACT_APP_NODE_URL ? process.env.REACT_APP_NODE_URL : "https://wallet.mainnet.alephium.org");
    const { connectionStatus, nodeProvider, account, signer } = useWallet()
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(true);

    const [rocketRange, setRocketRange] = useState<RocketRangeTypes.State>();
    const [userBet, setUserBet] = useState<RocketRangeUserBet>();
    const [rocketRangeRound, setRocketRangeRound] = useState<RocketRangeGameInstance[]>([{} as RocketRangeGameInstance]);
    const [alphLastPrice, setAlphLastPrice] = useState<number>(0);
    const [countdown, setCountdown] = useState<string>('00:00'); // Countdown timer

    const [upSmallTreshold, setUpSmallTreshold] = useState<Number>(0);
    const [upBigTreshold, setUpBigTreshold] = useState<Number>(0);

    const fetchData = async () => {
        const x = await RocketRange.at(getContractConfig("RocketRange").address).fetchState();
        setRocketRange(x);
        setUpSmallTreshold(Number(x.fields.gameSettings.upSmallTreshold));
        setUpBigTreshold(Number(x.fields.gameSettings.upBigTreshold));
        setLoading(false);
    };

    useEffect(() => { fetchData(); }, [])


    const topupOneAlph = () => {
        if (signer) {
            RocketRange.at(getContractConfig("RocketRange").address).transact.topUpNextRoundPot({
                signer: signer,
                attoAlphAmount: ONE_ALPH * 301n,
                args: {
                    amount: ONE_ALPH * 300n
                }
            })
        }
    }

    const claimProtocolFee = () => {
        if (signer) {
            RocketRange.at(getContractConfig("RocketRange").address).transact.claimProtocolFee({
                signer: signer,
                attoAlphAmount: ONE_ALPH,
            })
        }
    }

    const saveGameSettings = (e: any) => {
        e.preventDefault();
        if (rocketRange && signer) {
            const gameSettings = rocketRange?.fields.gameSettings;
            if (gameSettings) {
                gameSettings.upBigTreshold = BigInt(upBigTreshold + "");
                gameSettings.upSmallTreshold = BigInt(upSmallTreshold + "");
                console.log(gameSettings);
                RocketRange.at(getContractConfig("RocketRange").address).transact.updateGameSettings({
                    signer: signer,
                    attoAlphAmount: ONE_ALPH,
                    args: {
                        newGameSettings: gameSettings
                    }
                })
            }
        }
    }

    if (loading) return <div>Loading</div>
    return (
        <>
            <div className="w-full max-w-4xl mx-auto bg-gray-950 text-white rounded-lg shadow-md">
                <div className='p-6'>
                    <button className='bg-red-500 py-2 px-4' onClick={topupOneAlph}>Topup</button>
                    <button className='bg-red-500 ml-4 py-2 px-4' onClick={claimProtocolFee}>Claim</button>
                </div>
                <EventsDashboard />
                <form className="bg-gray-800 p-6 rounded-lg shadow-md space-y-4" onSubmit={saveGameSettings}>
                    <div>
                        <label htmlFor="upSmallTreshold" className="block text-sm font-medium text-gray-300 mb-1">
                            Small Up Threshold
                        </label>
                        <input
                            type="number"
                            id="upSmallTreshold"
                            value={upSmallTreshold + ""}
                            onChange={(e) => setUpSmallTreshold(e.target.valueAsNumber)}
                            className="w-full px-3 py-2 text-gray-900 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                            placeholder="Enter small up threshold"
                        />
                    </div>

                    <div>
                        <label htmlFor="upBigTreshold" className="block text-sm font-medium text-gray-300 mb-1">
                            Big Up Threshold
                        </label>
                        <input
                            type="number"
                            id="upBigTreshold"
                            value={upBigTreshold + ""}
                            onChange={(e) => setUpBigTreshold(e.target.valueAsNumber)}
                            className="w-full px-3 py-2 text-gray-900 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                            placeholder="Enter big up threshold"
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-red-600 text-white py-2 px-4 rounded-md font-medium hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                    >
                        Save Thresholds
                    </button>
                </form>
                <pre className='p-6' style={{ overflowX: "hidden" }}>
                    {JSON.stringify(rocketRange, null, 4)}
                </pre>
            </div>
        </>
    );

}


